import React, { useState, useEffect } from "react";
import {
  Modal,
  FieldText,
  FieldTextarea,
  Banner,
  Button,
  BodyText,
  Stack,
  Flex,
} from "@knowtex-ai/components";

export default function BoosterIssuesModal({ open, onOpenChange, macros, onResolved }) {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    if (macros && macros.length > 0) {
      setEntries(
        macros.map((m) => ({
          ...m,
          dot_phrase: m.dot_phrase || "",
          keywords: m.keywords || "",
          content: m.content || "",
        }))
      );
    }
  }, [macros]);

  const handleChange = (index, field, value) => {
    setEntries((prev) =>
      prev.map((entry, i) => {
        if (i !== index) return entry;
        if (field === "dot_phrase" && value && !value.startsWith(".")) {
          value = "." + value;
        }
        return { ...entry, [field]: value };
      })
    );
  };

  const allResolved = entries.every(
    (e) => e.dot_phrase && e.keywords && e.content
  );

  const handleSave = () => {
    if (!allResolved) return;
    onResolved(entries.map(({ issues, ...rest }) => rest));
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="Issues Detected"
      subtitle={`Knowtex detected issues with ${entries.length} dot phrase${entries.length !== 1 ? "s" : ""}. Please fill in the missing required fields.`}
      size="large"
    >
      <Stack gap={16}>
        {entries.map((entry, index) => {
          const fieldLabels = { dot_phrase: "Dot Phrase", keywords: "Keywords", content: "Content" };
          const missingLabels = (entry.issues || []).map((f) => fieldLabels[f] || f);

          return (
          <Stack key={index} gap={12} style={{ padding: 16, border: "1px solid #e5e7eb", borderRadius: 8 }}>
            <Banner variant="error" showIcon>
              Missing required field{missingLabels.length !== 1 ? "s" : ""}: <strong>{missingLabels.join(", ")}</strong>
            </Banner>

            <FieldText
              label="Dot Phrase"
              value={entry.dot_phrase}
              onChange={(e) => handleChange(index, "dot_phrase", e.target.value)}
              placeholder="Enter dot phrase (e.g. .example)"
              required
              error={!entry.dot_phrase && entry.issues.includes("dot_phrase") ? "This field is required" : undefined}
            />

            <FieldText
              label="Keywords"
              value={entry.keywords}
              onChange={(e) => handleChange(index, "keywords", e.target.value)}
              placeholder="Enter keywords (comma separated)"
              required
              error={!entry.keywords && entry.issues.includes("keywords") ? "This field is required" : undefined}
            />

            <FieldTextarea
              label="Content"
              value={entry.content}
              onChange={(e) => handleChange(index, "content", e.target.value)}
              placeholder="Enter dot phrase content"
              rows={3}
              required
              error={!entry.content && entry.issues.includes("content") ? "This field is required" : undefined}
            />
          </Stack>
          );
        })}

        <Flex justifyContent="flex-end" gap={12}>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={!allResolved}
          >
            Save & Continue
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}